var SupportOrdersFilterCollection, SupportOrdersFilterConditionsModel, SupportOrdersIteratorNonPaginatedCollection, SupportOrdersIteratorPaginatedCollection;

SupportOrdersIteratorNonPaginatedCollection = require('./orders_iterator_nonpaginated');

SupportOrdersIteratorPaginatedCollection = require('./orders_iterator_paginated');

SupportOrdersFilterConditionsModel = require('../models/orders_filter_conditions');

SupportOrdersFilterCollection = (function() {
  function SupportOrdersFilterCollection(options) {
    this.ordersModel = Groupon.Support.OrdersCollection;
    this.setSortAttribute(options.sort_attribute);
    this.setSortOrder(options.sort_order);
    this.sortedOrders = [];
    this.conditions = new SupportOrdersFilterConditionsModel;
    if (window.ordersPaginationEnabled) {
      this.iterator = new SupportOrdersIteratorPaginatedCollection(this);
    } else {
      this.iterator = new SupportOrdersIteratorNonPaginatedCollection(this, this.ordersModel);
    }
    this.pagination = null;
  }

  SupportOrdersFilterCollection.prototype.setSortAttribute = function(val) {
    switch (val) {
      case 'purchased_at':
        return this.sort_attribute = 'purchased_at';
      case 'merchant_name':
        return this.sort_attribute = 'merchant_name';
      default:
        return this.sort_attribute = 'purchased_at';
    }
  };

  SupportOrdersFilterCollection.prototype.getSortAttribute = function() {
    return this.sort_attribute;
  };

  SupportOrdersFilterCollection.prototype.setSortOrder = function(val) {
    switch (val) {
      case 'descending':
        return this.sort_order = 'descending';
      case 'ascending':
        return this.sort_order = 'ascending';
      default:
        return this.sort_order = 'descending';
    }
  };

  SupportOrdersFilterCollection.prototype.getSortOrder = function() {
    return this.sort_order;
  };

  SupportOrdersFilterCollection.prototype.getOrders = function(options, sucessCallback, errorCallback) {
    var _sucessCb, hash;
    _sucessCb = (function(_this) {
      return function(response) {
        var ref;
        if (response != null ? response.pagination : void 0) {
          _this.pagination = response.pagination;
        }
        if ((response != null ? (ref = response.orders) != null ? ref.length : void 0 : void 0) > 0) {
          response.orders = _this.sortOrders(response.orders);
        }
        return sucessCallback(response);
      };
    })(this);
    hash = {
      sort_order: this.sort_order,
      sort_attribute: this.sort_attribute
    };
    options = _.extend(options, hash);
    return this.ordersModel.fetchOrders(options, _sucessCb, errorCallback);
  };

  SupportOrdersFilterCollection.prototype.sortOrders = function(orders) {
    if (this.ordersModel.getNumberOfOrdersFetched() > this.sortedOrders.length) {
      if (this.sort_attribute === 'merchant_name') {
        if (this.sort_order === 'descending') {
          orders.sort((function(_this) {
            return function(a, b) {
              return _this.conditions.sortMerchantNameDescendingFn(a, b);
            };
          })(this));
        } else {
          orders.sort((function(_this) {
            return function(a, b) {
              return _this.conditions.sortMerchantNameAscendingFn(a, b);
            };
          })(this));
        }
      } else if (this.sort_attribute === 'purchased_at') {
        if (this.sort_order === 'descending') {
          orders.sort((function(_this) {
            return function(a, b) {
              return _this.conditions.sortPurchasedDateDescendingFn(a, b);
            };
          })(this));
        } else {
          orders.sort((function(_this) {
            return function(a, b) {
              return _this.conditions.sortPurchasedDateAscendingFn(a, b);
            };
          })(this));
        }
      }
      orders = _.filter(orders, (function(_this) {
        return function(order) {
          var orderFound;
          orderFound = _this.findOrderById(order.id);
          if (orderFound) {
            return false;
          } else {
            _this.sortedOrders.push(order);
            return true;
          }
        };
      })(this));
    }
    return orders;
  };

  SupportOrdersFilterCollection.prototype.findOrderById = function(orderId) {
    if (orderId) {
      orderId = orderId.toString();
      return _.find(this.sortedOrders, function(order) {
        var ref;
        return ((ref = order.id) != null ? ref.toString() : void 0) === orderId;
      });
    } else {
      return null;
    }
  };

  SupportOrdersFilterCollection.prototype.getFirstOrder = function() {
    if (this.sortedOrders.length > 0) {
      return this.sortedOrders[0];
    } else {
      return null;
    }
  };

  SupportOrdersFilterCollection.prototype.isOrdersInfoValid = function() {
    return this.iterator.isOrdersInfoValid();
  };

  return SupportOrdersFilterCollection;

})();

module.exports = SupportOrdersFilterCollection;

//# sourceMappingURL=data:application/json;base64,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
